import { useMutation, useQuery } from '@tanstack/react-query'

import { doNegotiation, getContextById, getScreenshot } from '../../api/session'

export const useContextById = (id: string) =>
  useQuery({
    queryKey: ['getContextById', id],
    queryFn: () => getContextById(id),
    enabled: !!id,
    refetchInterval: ({ state }) => {
      if (state.data?.data?.status === 'Completed') return false
      return 3000
    },
  })

export const useScreenshot = (url: string, isEnabled: boolean) =>
  useQuery({
    queryKey: ['getScreenshot', url],
    queryFn: () => getScreenshot(url),
    enabled: !!url && isEnabled,
  })

export const useNegotiation = () =>
  useMutation({
    mutationFn: doNegotiation,

    retry: (failureCount, error) => {
      if (failureCount >= 3) return false
      if (error instanceof Error && error.name === 'AbortError') return false
      return true
    },
  })
